import HSuiteApiService from '@/core/services/hsuiteApi.service'

async function GetAllBasecampProjects() {
  let result = null;
  await HSuiteApiService.get('/api/BasecampTask/GetAllProjects').then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function GetProjectsById(projectId) {
  let result = null;
  await HSuiteApiService.get('/api/BasecampTask/GetProjectsById',`?projectId=${projectId}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    throw ex;
  })

  return result;
}


async function GetAllBasecampProjectTodoLists(projectId, taskSets) {
  let result = null;
  // Define the payload as an object containing projectId and taskSet
  const payload = {
    projectId,
    taskSets
  };
  await HSuiteApiService.post(`/api/BasecampTask/GetAllTaskLists`, payload).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetBasecampTaskById(projectId, taskId) {
  let result = null
  await HSuiteApiService.get('/api/BasecampTask/GetTaskById',`?projectId=${projectId}&taskId=${taskId}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function GetAllBasecampProjectTodos(projectId, taskList, page, search, isCompleted) {
  let result = null;
  const payload = {
    projectId,
    taskList,
    page,
    search,
    isCompleted
  };
  await HSuiteApiService.post(`/api/BasecampTask/GetAllTasks`, payload).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function SearchProjectByNameOrId(searchQuery) {
  let result = null;
  await HSuiteApiService.get('/api/BasecampTask/SearchProjectByNameOrId',`?searchQuery=${searchQuery}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function GetPeopleOnProject(projectId) {
  let result = null;
  // Define the payload as an object containing projectId and taskSet
  const payload = {
    projectId
  };

  await HSuiteApiService.post(`/api/BasecampTask/GetPeopleOnProject`, payload).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function CreateTask(data) {
  let result = null;
  await HSuiteApiService.post(`/api/BasecampTask/createTask`, data).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateTask(data) {
  let result = null;
  await HSuiteApiService.post(`/api/BasecampTask/updateTask`, data).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetAllTaskTypes() {
  let result = null;
  await HSuiteApiService.get(`/api/ElisaTaskTypes/GetAllTaskTypes`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function FindTaskTypeByID(id) {
  let result = null;
  await HSuiteApiService.get(`/api/ElisaTaskTypes/FindTaskTypeByID/${id}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function DeleteTaskType(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/ElisaTaskTypes/DeleteTaskType`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateTaskType(data) {
  let result = null;
  await HSuiteApiService.post(`/api/ElisaTaskTypes/UpdateTaskType`, data).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function AddTaskType(data) {
  let result = null;
  await HSuiteApiService.post(`/api/ElisaTaskTypes/AddTaskType`, data).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetTaskTypesByFilter(filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/ElisaTaskTypes/GetTaskTypesByFilter`,`?filter=${filter}&pageSize=${pageSize}&pageIndex=${pageIndex}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function GetTaskCustomFieldsByFilter(filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/ElisaTaskCustomFields/GetTaskCustomFieldsByFilter`,`?filter=${filter}&pageSize=${pageSize}&pageIndex=${pageIndex}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function GetAllTaskCustomFieldsByTaskTypeIdAndFilter(id, filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/ElisaTaskCustomFields/GetAllTaskCustomFieldsByTaskTypeIdAndFilter/${id}`,`?filter=${filter}&pageSize=${pageSize}&pageIndex=${pageIndex}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function FindTaskCustomFieldByID(id) {
  let result = null;
  await HSuiteApiService.get(`/api/ElisaTaskCustomFields/FindTaskCustomFieldByID/${id}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function GetAllTaskCustomFieldsByTaskTypeId(taskTypeId) {
  let result = null;
  await HSuiteApiService.get(`/api/ElisaTaskCustomFields/GetAllTaskCustomFieldsByTaskTypeId/${taskTypeId}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}


async function DeleteTaskCustomField(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/ElisaTaskCustomFields/DeleteTaskCustomField`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateTaskCustomField(data) {
  let result = null;
  await HSuiteApiService.post(`/api/ElisaTaskCustomFields/UpdateTaskCustomField`, data).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function AddTaskCustomField(data) {
  let result = null;
  await HSuiteApiService.post(`/api/ElisaTaskCustomFields/AddTaskCustomField`, data).then(response => {
    result = response
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function CompleteTask(completionUrl) {
  let result = null;
  
  const payload = {
    completionUrl
  };
  await HSuiteApiService.post(`/api/BasecampTask/completeTask`, payload).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function InCompleteTask(completionUrl) {
  let result = null;
  
  const payload = {
    completionUrl
  };
  await HSuiteApiService.post(`/api/BasecampTask/InCompleteTask`, payload).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function AttachProject(leadId, projectId) {
  let result = null;
  const payload = {
    leadId,
    projectId
  };

  await HSuiteApiService.post(`/api/BasecampTask/AttachProject`, payload).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

export { 
  GetAllBasecampProjects,
  GetProjectsById,
  GetAllBasecampProjectTodoLists,
  GetAllBasecampProjectTodos,
  SearchProjectByNameOrId,
  GetPeopleOnProject,
  CreateTask,
  GetAllTaskTypes,
  FindTaskTypeByID,
  GetTaskCustomFieldsByFilter,
  DeleteTaskCustomField,
  UpdateTaskCustomField,
  AddTaskCustomField,
  FindTaskCustomFieldByID,
  GetAllTaskCustomFieldsByTaskTypeId,
  GetAllTaskCustomFieldsByTaskTypeIdAndFilter,
  DeleteTaskType,
  UpdateTaskType,
  AddTaskType,
  GetTaskTypesByFilter,
  GetBasecampTaskById,
  UpdateTask,
  InCompleteTask,
  CompleteTask,
  AttachProject
}
